import React from 'react'
import { Button } from './index'

import useTranlation from '../../translation/hook'

export default function UICardMaterial({state, methods,...props}){
    const {cardType, cardMaterial} = state
    const t = useTranlation()
    function buttonValue(materialName){
        const buttonText =  t("site_pages_shop_app_" + materialName.toLowerCase())
        return buttonText
    }
    return (
        <div className="uiPanel cardMaterialPanel">
            <div className="title">{t("site_pages_shop_app_select_material")}</div>
            <div className="uiRow uiToggleRow uiMaterialRow">
                {cardType.materials.map(material => (
                    <Button value={buttonValue(material.name)} 
                        key={material.name}
                        active={material.name === cardMaterial.name}
                        onClick={() => methods.selectCardMaterial(material.name)}/>            
                    )
                )}
            </div>
        </div>        
    )
}